export enum EnumNovidade {
	Sistema = 13,
	Bug = 14,
	Informativo = 15,
}
